module.exports = __webpack_public_path__ + "media/fonts/fa-brands-400-350d4991b53936090669e09e09ba11e0.eot";